/*
 * @Author: your name
 * @Date: 2020-01-08 10:54:51
 * @LastEditTime: 2021-01-25 11:35:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /static-kshdoctor/src/service/ShopService.js
 */
import request from '@/utils/request'
import {API} from './apiConfig'

export function getProvincePostage() {
	return request({
		method: 'get',
		url: API.getProvincePostage
	})
}

export function getAddressList() {
	return request({
		method: 'get',
		url: API.GetAddressList
	})
}

export function updataAddress(data) {
	return request({
		url: API.UpdateAddress,
		method: 'post',
		data
	})
}

export function deleteAddress(id) {
	return request({
		method: 'get',
		url: API.DeleteAddress,
		params: {
			id
		}
	})
}

export function setDefaultAddress(addressId) {
	return request({
		url: API.setDefaultAddress,
		method: 'post',
		params: {
			addressId
		}
	})
}

export function addAddress(data) {
	return request({
		url: API.AddAddress,
		method: 'post',
		data
	})
}

export function getAddressDetail(addressId) {
	return request({
		method: 'get',
		url: API.AddressDetail,
		params: {
			id: addressId
		}
	})
}

export function getShopList({commodityType = '', pageNo = 1, pageSize = 20, startPrice = '', endPrice = '', creTimeOrder = false, subjectId = ''}) {
	return request({
		method: 'post',
		url: API.ShopList,
		data: {
			commodityType,
			pageNo: pageNo,
			pageSize,
			minPrice: startPrice,
			maxPrice: endPrice,
			creTimeOrder,
			subjectId
		}
	})
}

export function searchProductList(data) {
	return request({
		method: 'post',
		url: API.ShopList,
		data: data
	})
}


export function getAttribution(mobile) {
	return request({
		method: 'get',
		url: API.getAttribution,
		params: {
			mobile: mobile
		}
	})
}

export function chargeMobile(mobile, chargeId) {
	return request({
		url: API.chargeMobile,
		method: 'post',
		params: {
			chargeId,
			mobile
		}
	})
}

export function getChargeList() {
	return request({
		method: 'get',
		url: API.chargeList
	})
}

export function getSpecialShopList({subjectId = '', pageNo = 1, pageSize = 20, startPrice = '', endPrice = ''}) {
	return request({
		method: 'get',
		url: API.specialShopList,
		params: {
			subjectId, pageNo, pageSize, startPrice, endPrice
		}
	})
}

export function getSpecialShopDetail(subjectId = '') {
	return request({
		method: 'get',
		url: API.specialShopDetail,
		params: {
			subjectId
		}
	})
}

export function getShopLevel(parentId = '888888') {
	return request({
		method: 'get',
		url: API.getShopLevel,
		params: {
			parentId
		}
	})
}

export function getShopSpecialList() {
	return request({
		method: 'get',
		url: API.getShopSpecialList
	})
}

export function getPacketInfo() {
	return request({
		method: 'get',
		url: API.packetInfo
	})
}

export function addCartCount(id, count) {
	return request({
		url: API.addCartCount,
		method: 'post',
		params: {
			count,
			skuId: id
		}
	})
}

export function delCartCount(id, count) {
	return request({
		url: API.delCartCount,
		method: 'post',
		params: {
			count,
			skuId: id
		}
	})
}

export function closeOrder(id) {
	return request({
		url: API.closeOrder,
		method: 'post',
		params: {
			orderId: id
		}
	})
}

export function getDelivery(orderId) {
	return request({
		method: 'get',
		url: API.getDelivery,
		params: {
			orderId
		}
	})
}

export function submitAfterSale(data) {
	return request({
		url: API.submitAfterSale,
		method: 'post',
		data
	})
}

export function confirmDelivery(afterSaleOrderId, delivery, deliveryNo) {
	return request({
		method: 'post',
		url: API.confirmDelivery,
		data: {
			deliverName: delivery, deliverNo: deliveryNo, afterSaleOrderId: afterSaleOrderId
		}
	})
}

export function closeAfterSale(id) {
	return request({
		url: API.closeAfterSale,
		method: 'get',
		params: {
			afterSaleOrderId: id
		}
	})
}

export function areaCodeList(parentId) {
	return request({
		method: 'get',
		url: API.areaCodeList,
		params: {
			parentId
		}
	})
}

export function cartCount() {
	return request({
		method: 'get',
		url: API.cartCount
	})
}

export function getAfterSaleDetail(orderId, skuId) {
	return request({
		method: 'get',
		url: API.getAfterSaleDetail,
		params: {
			orderId, skuId
		}
	})
}

export function getAfterSaleSupport(orderId, skuId) {
	return request({
		method: 'get',
		url: API.getAfterSaleSupport,
		params: {
			orderId, skuId
		}
	})
}

export function clearProduct(data) {
	return request({
		url: API.clearProduct,
		method: 'post',
		data
	})
}

export function getManagementColumnList(options) {
	return request({
		url: API.managementColumnList,
		method: 'get',
		params:options
	})
}

export function getSubjectList(options) {
	return request({
		url: API.subjectList,
		method: 'get',
		params: options
	})
}
